import APICall from "../APICall";
import { stringifyFilter } from "../utils/helperFunc";

const purseStats = async () => {
  const res = await APICall("purse/getmypursedetails", "GET");
  return res.data;
};

const withdrawToPlan = async (payload) => {
  const res = await APICall("purse/transferfund", "POST", payload);
  return res;
};

const searchHervestUserPurse = async (nuban) => {
  const res = await APICall(`purse/searchcustomer?customer=${nuban}`, "GET");
  return res;
};

const transferFunds = async (payload) => {
  const res = await APICall("purse/transferfund", "POST", payload);
  return res;
};

const addNewBeneficiary = async (payload) => {
  const res = await APICall("purse/addnewbeneficiary", "POST", payload);
  return res;
};

const fundPurseFromExistingCard = async (payload) => {
  const res = await APICall("purse/fundmypurse", "POST", payload);
  return res;
};

const downloadAccountStatement = async (fileType) => {
  const { data } = await APICall(
    "purse/accountstatement?filetype=" + fileType,
    "GET"
  );
  return data;
};

const requestAccountStatement = async (payload) => {
  const filters = stringifyFilter(payload);
  const res = await APICall(
    `transactions/generate-account-statement${filters}&filetype=pdf`,
    "GET"
  );
  return res;
};

const purseService = {
  purseStats,
  withdrawToPlan,
  searchHervestUserPurse,
  transferFunds,
  addNewBeneficiary,
  fundPurseFromExistingCard,
  downloadAccountStatement,
  requestAccountStatement,
};

export default purseService;
